<template>
  <div class="pt-4">
    <v-form ref="create_warehouse_form" lazy-validation @submit.prevent="addwarehouse()">
      <v-row justify="start" class="custome-form">
        <v-col cols="6" md="4">
          <v-row>
            <v-col cols="12" md="12" class="py-0 px-2">
              <label>{{ $lang.WAREHOUSE_NAME }}</label>
              <v-text-field
                  :placeholder="$lang.WAREHOUSE_NAME"
                  v-model="form.name"
                  single-line
                  outlined
                  dense
                  :rules="$rules.WAREHOUSE_NAME"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="12" class="py-0 px-2">
              <label>{{ $lang.PHONE_NUMBER }}</label>
              <v-text-field
                  :placeholder="$lang.PHONE_NUMBER"
                  v-model="form.phone_number"
                  single-line
                  outlined
                  dense
                  maxlength="10"
                  :rules="$rules.mobileRule"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="12" class="py-0 px-2">
              <label>{{ $lang.ALTERNATE_PHONE_NUMBER }}</label>
              <v-text-field
                  :placeholder="$lang.ALTERNATE_PHONE_NUMBER"
                  v-model="form.alternate_phone_number"
                  single-line
                  outlined
                  dense
                  maxlength="10"
                  :error-messages="(form.alternate_phone_number)&&(form.phone_number==form.alternate_phone_number)?$messages.MATCHING_PHONE_NUMBER_ERROR:''"
                  :rules="$rules.mobileRule"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="12" class="py-0 px-2">
              <label>{{ $lang.EMAIL_ID }}</label>
              <v-text-field
                  :placeholder="$lang.EMAIL_ID"
                  v-model="form.email"
                  single-line
                  outlined
                  dense
                  maxlength="50"
                  :rules="$rules.emailRule"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="12" class="py-0 px-2">
              <label>{{ $lang.PIN_CODE }}</label>
              <v-text-field
                  :placeholder="$lang.PIN_CODE"
                  v-model="form.pincode"
                  single-line
                  outlined
                  dense
                  maxlength="6"
                  :rules="$rules.pinCodeRule"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="12" class="py-0 px-2">
              <label>{{ $lang.CITY }}</label>
              <v-select
                  v-model="form.city"
                  :items="city_list"
                  item-text="city_name"
                  item-value="city_name"
                  :placeholder="$lang.CITY"
                  @focus="cityAutoComplete"
                  @change="setState"
                  append-icon="mdi-menu-down"
                  single-line
                  outlined
                  dense
                  return-object
                  :rules="$rules.cityRule"
                  :loading="city_loading"
              >
                <template v-slot:selection="{ item}">
                  {{ item.city_name }}, {{ item.state_name }}
                </template>
                <template v-slot:item="data">
                  <v-list-item-content>
                    <v-list-item-title v-html="data.item.city_name"></v-list-item-title>
                    <v-list-item-subtitle>{{ data.item.state_name }}</v-list-item-subtitle>
                  </v-list-item-content>
                </template>
              </v-select>
            </v-col>
            <v-col cols="12" md="12" class="py-0 px-2">
              <label>{{ $lang.FULL_ADDRESS }}</label>
              <v-textarea
                  clearable
                  :placeholder="$lang.FULL_ADDRESS"
                  v-model="form.address"
                  single-line
                  outlined
                  dense
                  auto-grow
                  rows="2"
                  :rules="$rules.fullAddressRule"
              ></v-textarea>
            </v-col>
          </v-row>
        </v-col>

        <v-col cols="2" md="1" class="large-screen"></v-col>
        <v-col cols="6" md=5 class="py-0 pl-5">
          <Map class="mt-5" @update="getLatLong" ref="map_elm"/>

          <p v-if="location_error">
            <small class="error-text">{{ $messages.SLELECT_LOCATION }}</small>
          </p>

          <v-btn color="primary" class="signup-btn-style mt-12 px-6" type="submit" :loading="btn_loading">
            <b>Continue</b>
          </v-btn>
        </v-col>

      </v-row>
    </v-form>

  </div>
</template>
<script type="text/javascript">

export default {
  components: {
    Map: () => import('@/components/common-components/google-map/GoogleMap.vue'),
  },
  data() {
    return {
      is_edit: false,
      location_error: false,
      warehouse_id: "",
      form: {
        name: "",
        phone_number: "",
        alternate_phone_number: "",
        email: "",
        address: "",
        pincode: "",
        city: "",
        state: "",
      },
      city_list: [],
      city_loading: false,
      btn_loading: false,


    }
  },
  created() {
    if (this.$route.name == "edit-warehouse") {
      this.is_edit = true
      this.warehouse_id = this.decrypt(this.$route.params.warehouse_id)
      this.getRetailerDetails()
    }
    this.cityAutoComplete()
  },
  methods: {
    /* set the  selected city and state */
    setState(item) {
      if (item) {
        this.form.state = item.state_name
        this.$emit('get-state', item.state_name)
      } else
        this.form.state = ""
    },

    /*  Add Edit Retailer  */
    addwarehouse() {
      const self = this
      if (!(self.$store.state.map_center.lng && self.$store.state.map_center.lat)) {
        this.location_error = true
        return false
      }


      if (this.$refs.create_warehouse_form.validate() == false)
        return false
      self.btn_loading = true
      console.log(self.form)
      var form = new FormData();

      console.log(self.form.city)

      form.append("name", self.form.name)
      form.append("phone_number", self.form.phone_number)
      form.append("alternate_phone_number", self.form.alternate_phone_number)
      form.append("email", self.form.email)
      form.append("address", self.form.address)
      form.append("pincode", self.form.pincode)
      form.append("state", self.form.state)

      form.append("city", self.form.city)
      if (self.form.city.city_name)
        form.append("city", self.form.city.city_name)

      form.append("warehouse_longitude", self.$store.state.map_center.lng)
      form.append("warehouse_latitude", self.$store.state.map_center.lat)

      let url = this.$urls.CREATE_WAREHOUSE
      if (this.is_edit) {
        form.append("warehouse_id", self.warehouse_id)
        url = this.$urls.EDIT_WAREHOUSE

      }


      const successHandler = (response) => {
        console.log(response)
        if (response.data.success) {
          self.$router.push({name: 'manage-warehouses'})

        }
      };
      const finallyHandler = () => {
        self.btn_loading = false
      };

      this.request_POST(self, url, form, successHandler, null, null, finallyHandler)

    },
    /* fetch retailer details  for the  edit data */
    getRetailerDetails() {
      const self = this
      let params = {
        warehouse_id: self.warehouse_id
      };
      self.table_loading = true

      const successHandler = (response) => {
        if (response.data.success) {
          self.form = response.data.data
          self.form.city = {
            city_name: response.data.data.city,
            state_name: response.data.data.state
          }

          self.$refs.map_elm.center = {
            lat: parseFloat(response.data.data.warehouse_latitude),
            lng: parseFloat(response.data.data.warehouse_longitude)
          }
          console.log(self.$refs.map_elm.center)
          self.$store.dispatch('setMapCenter', self.$refs.map_elm.center)

          setTimeout(() => {
            self.$refs.map_elm.map.setZoom(15);
          }, 400);


        }
      };
      const finallyHandler = () => {
        self.table_loading = false
        self.$store.dispatch('setPageLoader', false)
      };

      self.request_GET(self, self.$urls.WAREHOUSE_DETAILS, params, successHandler, null, null, finallyHandler)
    },
    getLatLong(latlong) {
      this.location_error = false
    },
  }

}

</script>